import { IconButton, Stack, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import {
  CheckRadio,
  DeleteIcon,
  EditableChip,
  FlagFilled2Icon,
  FlagFilledIcon,
  FlagIcon,
} from "components";
interface ChecklistItemProps {
  checklistItem?: any;
  onRemove?: () => void;
  onChange: (data: any) => void;
  isNew?: boolean;
  isEditMode?: boolean;
  source: "controlCenter" | "other";
  checklistInputError?: boolean;
}
export const ChecklistItem = ({
  isEditMode,
  checklistItem,
  onChange,
  onRemove,
  isNew,
  source,
  checklistInputError,
}: ChecklistItemProps) => {
  const theme = useTheme();
  const [isChecked, setIsChecked] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);

  useEffect(() => {
    if (checklistItem?.is_important) {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }

    if (checklistItem?.is_completed) {
      setIsCompleted(true);
    } else {
      setIsCompleted(false);
    }
  }, [checklistItem]);

  function changeChecked(isSelected: boolean) {
    console.log(checklistItem);
    if (isNew) {
      return setIsChecked(isSelected);
    }
    onChange({
      ...checklistItem,
      is_important: isSelected,
    });
  }
  function changeCompleted(isCompleted: boolean) {
    console.log(checklistItem);
    if (isNew) {
      return setIsCompleted(isCompleted);
    }
    onChange({
      ...checklistItem,
      is_completed: isCompleted,
    });
  }

  const handleTextChange = (value: string) => {
    if (isNew) {
      value.trim().length > 0 &&
        onChange({
          checklist_item_name: value,
          order: 1,
          is_important: isChecked,
          is_completed: isCompleted,
        });
      return;
    }
    const currentdata = checklistItem;
    currentdata["checklist_item_name"] = value;
    onChange(checklistItem);
  };

  return (
    <Stack sx={{ width: "100%" }}>
      <Stack
        direction={"row"}
        sx={{
          width: "100%",
          gap: "16px",
          alignItems: "center",
          border: checklistInputError
            ? `1px solid ${theme.palette.error.main}`
            : `1px solid ${theme.palette.neutral["015"]}`,
          borderRadius: "4px",
          pl: source === "controlCenter" ? "0px" : "8px",
          // pr: "16px",
        }}
      >
        {source === "other" && !isNew ? (
          <CheckRadio
            status={isCompleted ? "checked" : "unchecked"}
            onClick={() => changeCompleted(!isCompleted)}
          />
        ) : (
          <></>
        )}

        <EditableChip
          isEditMode={isEditMode}
          placeholder="Type checklist here..."
          value={checklistItem?.checklist_item_name || ""}
          onEdit={(newValue) => {
            handleTextChange(newValue);
          }}
          multiline
          typographySx={{
            width: "fit-content",
            maxWidth: "100%",
            minWidth: "200px",
            height: "fit-content",
            ...theme.typography["body-medium"],
          }}
          inputSx={{
            width: "100%",
            maxWidth: "100%",
            // minWidth: "200px",
            bgcolor: theme.palette.darkBg.high,
            borderBottom: `2px solid ${theme.palette.primary.main}`,
            ...theme.typography["body-medium"],
          }}
          inputProps={{
            maxlength: 100,
          }}
        />

        <Stack
          direction={"row"}
          justifyContent={"flex-end"}
          alignItems={"center"}
        >
          <IconButton onClick={() => changeChecked(!isChecked)}>
            {isChecked ? (
              <FlagFilled2Icon fontSize="small" color={"error"} />
            ) : (
              <FlagIcon fontSize="small" />
            )}
          </IconButton>
          {
            <IconButton
              onClick={onRemove}
              disabled={isNew}
              sx={{
                visibility: isNew ? "hidden" : "initial",
              }}
            >
              <DeleteIcon />
            </IconButton>
          }
        </Stack>
      </Stack>
      {checklistInputError && (
        <Typography
          variant="body-small"
          sx={{ color: "error.main", margin: "4px 12px" }}
        >
          Checklist item required
        </Typography>
      )}
    </Stack>
  );
};
